export class Contribution {
    paymentDate: string;
    maxOut: string;
    contriAmount: string;
    miscAmount: string;
    noOfKids: number;
    studentName: string;
    projectName: string;
}
